import React from 'react'

//styles
import './spacer.sass'

const Spacer = () => <div className="spacer-div" />

export default Spacer
